module.exports = __webpack_public_path__ + "images/nest-f6a5fe7a7b1ca850e8d49c43c905683e.jpg";